import React, { useEffect, useState } from 'react';
import { PieChartMultiChart } from '../components/PieChartMultiChart';
import { Grid } from '@mui/material';
import { useEstadisticasDsKey } from '../hooks/useEstadisticasDsKey';
import { dataPieChar } from '../../utils/types/pieChart.types';
import { mapperEstadoLlavesToDataPieChar } from '../../utils/mappers/mapperEstadoLlavesToDataMultiChar';
import { useStylesBorder } from '../../utils/styles/styles';
import { useProductos } from '../hooks/useProductos';

interface LlavesChartProps {
   fecha: Date
}

const categoriasIni = {
   0: {
      anulado: 'Anuladas',
      nuevo: 'Nuevas',
      vigente: 'Vigentes',
      expirado: 'Expiradas'
   }
};

export const LlavesPorEstado: React.FC<LlavesChartProps> = ({ fecha }) => {
   const { classes } = useStylesBorder();
   const { getAllProductos } = useProductos();
   const [dataChart, setDataChart] = useState<dataPieChar[]>([]);
   const { getEstadoLlavesAnual } = useEstadisticasDsKey();
   const [categorias, setCategorias] = useState<Record<number, Record<string, string>>>(categoriasIni);

   const fetchLEstadosLlaves = async () => {
      const result = await getEstadoLlavesAnual({ fecha: fecha });
      if (result) {
         const estadoLlaveAnual: dataPieChar[] = mapperEstadoLlavesToDataPieChar({ data: result });
         setDataChart(estadoLlaveAnual);
      }
   };

   const fetchAllProductos = async () => {
      const result = await getAllProductos();
      if (result) {
         const prod: Record<string, string> = result.reduce((acc: Record<string, string>, item) => {
            acc[item.codigo] = item.denominacion;
            return acc;
         }, {});
         setCategorias({ ...categorias, 1: prod });
         fetchLEstadosLlaves();
      }
   };

   useEffect(() => {
      fetchAllProductos();
   }, []);

   return (
      <Grid container className={classes.border}>
         <PieChartMultiChart
            titleLevel={{ 0: "Llaves por Estado", 1: "Llaves por Producto" }}
            data={dataChart}
            categories={categorias}
            defaultSlider={{ end: fecha.getMonth(), start: 0 }}
            maxLevel={1}
         />
      </Grid>
   );
};
